import {Component, OnInit} from '@angular/core';
import {Announcement} from '../../models/announcement';
import {AnnouncementService} from '../../services/announcement.service';

@Component({
  selector: 'app-announcements',
  templateUrl: './announcements.component.html',
  styleUrls: ['./announcements.component.scss']
})
export class AnnouncementsComponent implements OnInit {

  announcements: Announcement[] = [];

  constructor(private announcementService: AnnouncementService) {
  }

  ngOnInit(): void {
    this.getAnnouncements();
  }

  private getAnnouncements(): void {
    this.announcementService.getAllAnnouncements().subscribe(res => {
      this.announcements = res;
    });
  }

}
